const useGlobalNav = (pageType, product) => {
  const excludeGlobalNavOn = [
    'chart-enterprise',
    'chart-og',
    'chart-og-ppc',
    'competitor',
    'competitor-ppc',
    'consideration',
    'consideration-competitor',
    'consideration-ppc',
    'discovery',
    'discovery-organic',
    'enterprise',
    'ppc-diagram-lander',
  ];

  const hasGlobalNav = !excludeGlobalNavOn.includes(pageType || '') && product !== 'co';

  return hasGlobalNav;
};

export default useGlobalNav;
